import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../../core/util/apifeatures';
import { BannerListCSSStyleImpl } from './bannerlistcss';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { BannerListViewImpl } from './bannerlistview';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { BannerSearchListAPIModelImpl, BannerSearchListAPIModel } from './bannersearchlistapimodel';
import { MusicboxBannerListAPIModelImpl } from './musicboxbannerlistapimodel';
import { GetBannerDetailsListAPIModelImpl } from './getbannerlistapimodel';
import { CRBTUIComponent, CRBTUIComponentProps } from '../../crbt/crbtuicomponent';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { BannerListToneViewModelImpl } from  './tones/bannerlistviewmodel';




export interface BannerListComponentProps extends CRBTUIComponentProps
{
   searchKey:string;
   bannerType: string;
   bannerOrder: string;
}

export interface BannerListComponentHandler extends UIComponentHandler
{
    loadMoreTones(startIndex: number, offset: number): void;
    onDataNotLoaded(isNotLoaded: boolean): void;
}
export interface  BannerListComponentState extends UIComponentState
{
    isDataNotLoaded: boolean;
}

export class BannerListComponent extends CRBTUIComponent<BannerListComponentProps, BannerListComponentState> 
implements BannerListComponentHandler
{
    private bannerListViewModel: BannerListToneViewModelImpl;

    constructor(props: BannerListComponentProps)
    {
        super(props);
        this.bannerListViewModel = new BannerListToneViewModelImpl(this.props.context, "40px", 
        this.props.context.getResources().getString(Strings.search_results_for));
        this.bannerListViewModel.setListDatas([]);
        this.state ={isDataNotLoaded:false};
    }
    onDataNotLoaded(isNotLoaded: boolean): void {
        this.setState({isDataNotLoaded: isNotLoaded});
      }
  componentDidMount()
       {
        (this.getView() as BannerListViewImpl).showLoader();
        this.getAPIModel().getListofBannerTones(this.props.bannerOrder, this.props.bannerType ,this.props.searchKey, 0, +this.props.context.getConfigurationSettings().getProperty(this.getContext().getResources().getString(Strings.fetch_limit)));
       }
       componentWillReceiveProps(nextProps: BannerListComponentProps)
       {
   
        (this.getView() as BannerListViewImpl).showLoader();
           (this.getView() as BannerListViewImpl).setListOfDatas([]);
         
   
           this.setState({isDataNotLoaded: false});
          
           
           this.getAPIModel().getListofBannerTones(this.props.bannerOrder, this.props.bannerType ,this.props.searchKey, 0, +this.props.context.getConfigurationSettings().getProperty(this.getContext().getResources().getString(Strings.fetch_limit)));
       }
   
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new BannerListViewImpl(this.bannerListViewModel, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new BannerListCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return this.getBannerAPIModel(applicationContext, apiModelHandler);
    }

    loadMoreTones(startIndex: number, offset: number): void 
    {
        this.getAPIModel().getListofBannerTones(this.props.bannerOrder, this.props.bannerType, this.props.searchKey, startIndex, offset);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as BannerListViewImpl).dismissLoader();
        this.bannerListViewModel.setListDatas((data as ToneDto[]));
        this.setState({ isDataNotLoaded:   this.bannerListViewModel.getListOfDatas().length > 0 ? false :  true}, ()=>
        {
            this.bannerListViewModel.getListOfDatas().length > 0 && this.bannerListViewModel.playFirstTone(0);
        });
        window.scrollTo(0,0);
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as BannerListViewImpl).dismissLoader();
        this.bannerListViewModel.getListOfDatas().length = 0;
        this.setState({ isDataNotLoaded: true});
    
        window.scrollTo(0,0);
        }

    getAPIModel(): BannerSearchListAPIModel
    {
        return (super.getAPIModel() as BannerSearchListAPIModel);
    }

    private getBannerAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        if(this.props.bannerType === this.getContext().getResources().getString(Strings.manual) || this.props.bannerType === this.getContext().getResources().getString(Strings.prebooking))
        {
            return new GetBannerDetailsListAPIModelImpl(applicationContext, apiModelHandler);
        }
        else if(this.props.bannerType === this.getContext().getResources().getString(Strings.music_box))
        {
            return new MusicboxBannerListAPIModelImpl(applicationContext, apiModelHandler);
        }
        else
        {
            return new BannerSearchListAPIModelImpl(applicationContext, apiModelHandler);
        }
    }
 

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerlist/bannerlistcomponent.tsx